














import {Component, Prop, Vue} from 'vue-property-decorator'
import {UploadConfig} from '@/config/upload.config'

@Component
export default class ModalUpload extends Vue {
  @Prop({type: Array, default: () => []}) value!: string[]
  @Prop({type: String, required: true}) title!: string
  @Prop({type: Object, default: null}) config?: UploadConfig | null

  get urls() {
    return this.value
  }

  set urls(val: string[]) {
    this.$emit('input', val)
  }
  changeReplicarCTE() {
    this.$emit('changeReplicarCTE')
  }
  close() {
    this.$modal.close('upload')
  }

  openEvent() {
    this.$emit('open')
  }

  closeEvent() {
    this.$emit('close')
  }

  done(urls: string[]) {
    this.$emit('done', urls)
    this.close()
  }
}
